module.exports = __webpack_public_path__ + "static/media/symbol-defs.2598ea2d.svg";